import { createReducer, on, Action } from '@ngrx/store';
import { BeneficialOwnerPEP, IndividualPEP } from 'src/app/modules/pep-list/pep-list.interface';

import { clearPepList, setPEPList } from './pep-list.actions';

export const pepListFeatureKey = 'pepList';

export interface PepListState {
  pepList: (IndividualPEP | BeneficialOwnerPEP)[];
}

export const initialState: PepListState = {
  pepList: []
};

const pepListReducer = createReducer(
  initialState,
  on(setPEPList, (state: PepListState, props) => {
    return {
      ...state,
      pepList: props.individualPepList
        .concat(props.beneficialOwnerPEPList as any)
        .sort((a: IndividualPEP | BeneficialOwnerPEP, b: IndividualPEP | BeneficialOwnerPEP) => {
          return Date.parse(b.modified_date) - Date.parse(a.modified_date);
        })
    };
  }),
  on(clearPepList, () => initialState)
);

export function reducer(state: PepListState | undefined, action: Action) {
  return pepListReducer(state, action);
}
